import React from 'react';
import {
  Icon,
  Row,
  Col,
} from 'antd';
import styled from 'styled-components';
import moment from 'moment-timezone';
import {
  SpH5,
  SpText,
  SpTextMute,
} from 'components/DesignKit';

type Props = {
  steps: Object,
  selectedAccount: Object,
};

const HorizontalTimeline = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0px;
  list-style: none;
  width: 100%;
  margin: 20px;
  position: relative;
  top: 0px;
  left: 0px;
`;

const HorizontalTimelineStep = styled.li`
  flex: 1;
  dipslay: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 20px 20px 20px 0px;
  border-top: ${(props) => `${props.thickness} solid ${props.lineColor}`};
`;

const InformationContainer = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  top: -30px;
  left: 0px;
`;

const LineDot = styled(Icon)`
  position: relative;
  left: 0px;
  top: -35px;
  z-index: 1000;
  background-color: #fff;
`;

const HorizontalTimelineBar = (props: Props) => {
  const {
    steps,
    selectedAccount,
  } = props;

  return (
    <HorizontalTimeline>
      {
        steps.map((step, idx) => (
          <HorizontalTimelineStep
            thickness="5px"
            lineColor={idx < steps.length - 1 ? '#00c289' : 'transparent'}
          >
            <LineDot type="check-circle" style={{ fontSize: '20px', color: '#00c289' }} />
            <InformationContainer>
              <Row>
                <Col span={24}>
                  <SpH5>{step.title}</SpH5>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <SpText>{step.subtext}</SpText>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <SpTextMute>{moment
                    .utc(step.timestamp)
                    .tz(selectedAccount.timezone)
                    .format('MMM DD, YYYY, hh:mm a')}
                  </SpTextMute>
                </Col>
              </Row>
            </InformationContainer>
          </HorizontalTimelineStep>
        ))
      }
    </HorizontalTimeline>
  );
};

export default HorizontalTimelineBar;
